<template>
    <component :is="template">
        <v-container>
            <div class="contents-area">
                <div class="contents-area__inner mx-auto" style="max-width:800px">
                    <div class="tit-wrap tit-wrap--unberline">
                        <h2 class="tit">상품권 구매하기</h2>
                        <div class="mt-4px mt-lg-8px font-size-14 font-size-md-16 grey--text text--garken-3">
                            PG 결제를 통해 나누리 캐시 교환권을 구매하실 수 있습니다.
                        </div>
                    </div>

                    <template v-if="!order._id">
                        <div class="mx-auto" style="max-width:480px">
                            <v-row class="ma-n1">
                                <v-col class="pa-1">
                                    <v-btn x-large block @click="exit"> 홈으로 </v-btn>
                                </v-col>
                                <v-col class="pa-1">
                                    <v-btn x-large block color="primary" @click="more"> 추가 구매하기 </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                    <template v-else-if="gainable">
                        <v-card class="my-20px my-lg-40px mx-auto" max-width="480" color="transparent" elevation="0">
                            <v-card-title class="justify-center"> 나누리캐시 자동충전 </v-card-title>
                            <v-card-text class="pb-0 text-center">
                                충전 전 구매하신 상품권 내역을 다시 확인해주세요.
                            </v-card-text>
                        </v-card>

                        <nshop-order-view-pins v-bind="{ value: order }" dense class="my-20px my-lg-40px mx-auto" style="max-width:480px" />

                        <purchase-gain-amount v-bind="{ value: order }" dense class="my-20px my-lg-40px mx-auto" style="max-width:480px" />

                        <div class="mx-auto" style="max-width:480px">
                            <v-row class="ma-n1">
                                <v-col class="pa-1">
                                    <v-btn x-large block @click="exit"> 취소하기 </v-btn>
                                </v-col>
                                <v-col class="pa-1">
                                    <v-btn x-large block color="primary" v-bind="{ loading }" @click="gain"> 충전하기 </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                    <template v-else-if="true">
                        <v-card class="my-20px my-lg-40px" color="transparent" elevation="0">
                            <v-card-title class="justify-center"> 자동충전이 불가능한 주문입니다 </v-card-title>
                            <v-card-text class="text-center">
                                주문이 완료되지 않았거나<br />
                                이미 충전이 완료된 주문입니다.
                            </v-card-text>
                        </v-card>

                        <div class="mx-auto" style="max-width:480px">
                            <v-row class="ma-n1">
                                <v-col class="pa-1">
                                    <v-btn x-large block @click="exit"> 홈으로 </v-btn>
                                </v-col>
                                <v-col class="pa-1">
                                    <v-btn x-large block color="primary" @click="more"> 추가 구매하기 </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                </div>
            </div>
        </v-container>
        <common-loader v-bind="{ loading }" />
        <common-message-dialog ref="messageDialog" />
    </component>
</template>

<script>
import api from "@/api";
import { initNshopOrder } from "@/store/nshop";

import CommonLoader from "@/components/common/common-loader.vue";
import CommonMessageDialog from "@/components/common/common-message-dialog.vue";
import NshopOrderViewPins from "@/components/client/nshop/order/nshop-order-view-pins.vue";
import PurchaseGainAmount from "@/components/client/purchase/purchase-gain-amount.vue";

export default {
    components: {
        CommonLoader,
        CommonMessageDialog,
        NshopOrderViewPins,
        PurchaseGainAmount,
    },
    data: () => ({
        order: initNshopOrder(),

        loading: false,
    }),
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        _order() {
            return this.$route?.query?._order;
        },
        gainable() {
            return this.order.gainable;
        },
    },
    methods: {
        more() {
            this.$router.go(-1);
        },
        exit() {
            this.$router.push("/");
        },

        // messageDialog 는 비동기 테마 컴포넌트(<component :is>) 슬롯 안에 있어
        // mounted 시점엔 아직 렌더되지 않았을 수 있다. ref 가 잡힐 때까지 대기 후 진행한다.
        waitMessageDialog() {
            return new Promise((resolve) => {
                const timer = setInterval(() => {
                    if (this.$refs.messageDialog) {
                        clearInterval(timer);
                        resolve();
                    }
                }, 50);
            });
        },
        async init() {
            if (!this.$store.state.payload?._user) {
                await this.waitMessageDialog();
                this.$refs.messageDialog.open("로그인 후 사용하실 수 있는 기능입니다.", () => {
                    this.$router.replace(`/login?to=/purchase/gain?_order=${this._order}`);
                });
                return;
            }

            let _id = this._order;
            if (!_id) return;

            this.loading = true;

            try {
                let { order } = await api.v1.me.nshop.orders.get({ _id });

                let updates = order._id == this._order;
                if (updates) this.order = initNshopOrder(order);
                if (updates) this.loading = false;
            } catch (error) {
                console.error(error);
                this.loading = false;
            }
        },

        async gain() {
            if (!this.$store.state.payload?._user) {
                await this.waitMessageDialog();
                this.$refs.messageDialog.open("로그인 후 사용하실 수 있는 기능입니다.", () => {
                    this.$router.replace(`/login?to=/purchase/gain?_order=${this._order}`);
                });
                return;
            }

            let _id = this._order;
            if (!_id) return;

            this.loading = true;

            try {
                let { order } = await api.v1.me.nshop.orders.gain.post({ _id });

                let updates = order._id == this._order;
                if (updates) this.order = initNshopOrder(order);
                if (updates) this.loading = false;
            } catch (error) {
                console.error(error);
                this.loading = false;
            }
        },
    },
    watch: {
        _order() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>
